export default __webpack_public_path__ + "static/media/DNo.30-3.7965e162.jpg";